"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var paths = {
    AUTH_LOGIN: '/auth',
    AUTH_LOGOUT: '/auth/logout',
    DEVICE: '/device',
    ELEMENT_SETTINGS: '/user/element_settings',
    INBOX_FETCH: '/inbox',
    INBOX_READ: '/inbox/read',
    INBOX_READ_ALL: '/inbox/read-all',
    INFO_ASSETS: '/info/assets',
    LOCATION_FETCH: '/location/info',
    PORTFOLIO: '/portfolio',
    SWAP_ASSETS: '/swap/assets',
    SWAP_ORDER: '/swap/order',
    SWAP_ORDER_HISTORY: '/swap/order_history',
    SWAP_ORDER_SAVE: '/swap/order/save',
    SWAP_QUOTE: '/swap/quote',
    SWAP_RATE: '/swap/rate',
    TRANSACTION_HISTORY: '/transaction/history',
    TRANSACTION_UTXO: '/transaction/utxo',
    TRANSACTION_RECENT: '/transaction/recent',
    USER_DETAILS: '/user/details',
    USER_NOTIFICATIONS_GENERAL: '/user/notifications/general',
    USER_NOTIFICATIONS_PRICING: '/user/notifications/pricing',
    USER_NOTIFICATIONS_PRICING_DELETE: '/user/notifications/pricing/delete',
    USER_PREFERENCES: '/user/preferences',
    USER_PREFERENCES_CURRENCY: '/user/preferences/currency',
    USER_PREFERENCES_CHAIN_PRIORITY: '/user/preferences/chain_priority',
    USER_PREFERENCES_CHAIN_PROPERTIES: '/user/preferences/chain_properties',
    USER_PREFERENCES_WALLET_ORDER: '/user/preferences/wallet_order',
    WALLET_FETCH: '/wallet',
    WALLET_GET_ADDRESS: '/wallet/address',
    WALLET_PREFERENCES: '/wallet/preferences',
    MARKETS_HISTORIC: '/markets/historic',
    SIGN_URL: '/sign',
    V2_AUTH_LOGIN: '/auth/authorize',
    V2_AUTH_LOGOUT: '/auth/logout',
    V2_SUMSUB_RETRIEVE_ACCESS_TOKENS: '/kyc/sumsub/retrieve-access-token',
    V2_USER_CREATE_EMAIL: '/user/create-user-email',
    V2_USER_CREATE_PROVIDER: '/user/create-user-provider',
    V2_USER_DETAILS: '/user/user-details',
    V2_VERSE_SALE_STARTED: '/verse/sale-started',
    V2_VERSE_ACCEPT_TERMS: '/verse/accept-terms',
    V2_VERSE_TERMS: '/verse/terms',
    V2_VERSE_KYC_STATUS: '/verse/kyc-status',
    V2_VERSE_CLAIM: '/verse/claim',
    V2_VERSE_CREATE_CLAIM: '/verse/create-claim',
    V2_VERSE_PAYMENT: '/verse/payment',
    V2_VERSE_TRANSACTION: '/verse/transaction',
    V2_VERSE_MERKLE_PROOF: '/verse/proof',
};
var endpoints = {};
Object.keys(paths).forEach(function (key) {
    if (key.startsWith('V2'))
        endpoints[key] = constants_1.API_V2_URL + paths[key];
    else
        endpoints[key] = constants_1.API_URL + paths[key];
});
exports.default = endpoints;
